var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"hint"},[(_vm.warning)?[_vm._v(_vm._s(_vm.warningText)+": ")]:_vm._e(),_c('span',{class:_vm.warning ? 'warning' : ''},[_vm._v(_vm._s(_vm.count))]),_vm._v(" of "+_vm._s(_vm.max)+" ")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }